import { StockEditCmd } from "../edit/editCmd"
import { createLookup, defineDirective, IOmniaShell, ITypedStock, StockType } from "../omnia"
import { ferts, manure, seeds } from "../strings"
import { IMmExport, IStocksModuleContext, IStocksService } from "../types"
import { StockVm } from "../vm/stockVm"
import { createStockVm } from "../vm/utils"

export interface IColumnHeader {
    title: string,
    text: string,
    iconClass: string
}

export interface IColumnContents {

    stockType: StockType,
    stocks: StockVm[];

    header: IColumnHeader;

}


export class StocksDashboardCtrl {


    static create() {

        return defineDirective(StocksDashboardCtrl, "app/stocks/dashboard/dashboard.html", {
            context: "="
        });

    }

    private context: IStocksModuleContext;

    private stocks: StockVm[];
    private exports: { [manureStockId: number]: IMmExport[] } = {}

    private editTarget: StockVm;
    private editOp: ng.IPromise<any>;

    private typeFilter: StockType;

    columns: IColumnContents[]
    visibleTypes: IColumnContents[]

    static $inject = ["$scope", "OmniaStocksService", "OmniaShell"];

    constructor(
        $scope: ng.IScope,
        private stocksSvc: IStocksService,
        shell: IOmniaShell,
        private readOnly = shell.isReadOnly(p => p.stocks)) {

        $scope.$watch(() => stocksSvc.getStocks(), stocks => this.setupStocks(stocks));

    }

    private setupStocks(stocks: ITypedStock[]) {

        this.stocks = (stocks || []).map(stock => createStockVm(stock));

        this.columns = [
            this.getColumn(StockType.Seed, { title: seeds, text: "seed", iconClass: "seed" }),
            this.getColumn(StockType.Fertiliser, { title: ferts, text: "fertiliser", iconClass: "fertiliser" }),
            this.getColumn(StockType.Manure, { title: manure, text: "manure", iconClass: "manure" }),
        ]

        this.exports = createLookup(this.stocksSvc.getManureExports(), e => e.ManureStockId)

        this.setTypeFilter(null);

    }


    private setTypeFilter(type: StockType) {

        this.visibleTypes = type
            ? this.columns.filter(t => t.stockType == type)
            : this.columns

        this.typeFilter = type;

    }

    hasActiveTypeFilter(): boolean {
        return !!this.typeFilter;
    }

    private getColumn(stockType: StockType, header: IColumnHeader) {


        header.iconClass = "icon icon-stock-" + header.iconClass;

        return {
            header: header,
            stockType: stockType,
            stocks: this.stocks.filter(s => s.stockType == stockType)
        }

    }


    private canEditStock(stock: StockVm): boolean {
        return !this.isInEditMode() && !!stock && !!this.context;
    }

    private editStock(stock: StockVm, duplicate?: boolean) {
        if (this.canEditStock(stock)) {
            var cmd = new StockEditCmd(this.context);
            this.editTarget = stock;
            this.editInternal(cmd.editStock(stock.stock, duplicate));
        }
    }

    duplicateStock(stock: StockVm) {
        this.editStock(stock, true);
    }

    canCreateStock(type: StockType): boolean {
        return (!this.readOnly) && !this.isInEditMode();
    }

    createStock(type: StockType) {
        var cmd = new StockEditCmd(this.context);
        this.editInternal(cmd.createStock(type));
    }

    public isInEditMode(): boolean {
        return !!this.editOp;
    }

    private editInternal(op: ng.IPromise<any>) {
        this.editOp = op.then(() => {
            this.editOp = null;
            this.editTarget = null;
        });
    }

    canFilter(column: IColumnContents): boolean {

        if (column) {

            let type = column.stockType;

            if (this.editTarget) {
                return (type == this.editTarget.stockType);
            }

            return column.stocks && (column.stocks.length > 0);

        }

    }

    toggleFilter(type: StockType) {
        this.setTypeFilter(type == this.typeFilter ? null : type);
    }

    getExports(stock: StockVm) {

        if (stock.stockType == StockType.Manure) {
            return this.exports[stock.stock.ManureStockId]
        }


    }
}
